import React from 'react';
import 'stream-chat-react';
import { noop } from '../../../utils/index.js';
import '../../../chat_context.js';
import { useChatApi } from '../../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useChatMembers = (channel) => {
    const [chatMembers, setChatMembers] = React.useState([]);
    const [loadingChatMembers, setLoadingChatMembers] = React.useState(false);
    const api = useChatApi();
    React.useEffect(() => {
        if (!channel)
            return;
        setLoadingChatMembers(true);
        api.chat
            .get(`me/conversations/${channel.id}/members`, { per_page: 100 }, { unpaginated: true })
            .then((members) => {
            setChatMembers(members);
            setLoadingChatMembers(false);
        })
            .catch(noop);
    }, [channel]);
    return { chatMembers, loadingChatMembers };
};

export { useChatMembers };
//# sourceMappingURL=use_chat_members.js.map
